// Remove elemento Total riscado injetado pelo Vitals no carrinho lateral
function removerTotalVitals() {
  var footer = document.querySelector('.mini-cart__drawer-footer');
  if (!footer) return;
  // Procura por elementos com texto riscado ou que contenham 'Total' + preco riscado
  footer.querySelectorAll('*').forEach(function(el) {
    var style = el.getAttribute('style') || '';
    var computedTD = window.getComputedStyle(el).textDecoration || '';
    if (
      style.indexOf('line-through') > -1 ||
      computedTD.indexOf('line-through') > -1 ||
      el.tagName === 'S' ||
      el.tagName === 'DEL'
    ) {
      // Sobe ate o pai direto do footer e esconde
      var parent = el;
      while (parent.parentElement && parent.parentElement !== footer) {
        parent = parent.parentElement;
      }
      if (parent.parentElement === footer) {
        parent.style.display = 'none';
      }
    }
  });
}

// Observa o footer do carrinho para agir quando o Vitals injeta o elemento
function observarFooterCart() {
  var footer = document.querySelector('.mini-cart__drawer-footer');
  if (!footer) {
    setTimeout(observarFooterCart, 500);
    return;
  }
  removerTotalVitals();
  var obs = new MutationObserver(function() {
    removerTotalVitals();
  });
  obs.observe(footer, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', observarFooterCart);
document.addEventListener('cart:open', function() { setTimeout(removerTotalVitals, 300); });
document.addEventListener('cart:updated', function() { setTimeout(removerTotalVitals, 300); });

// ---- Orcamento PDF ----

function formatMoney(cents) {
  return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
}

var QR_SITE = 'https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=' + encodeURIComponent('https://luzlight.com.br');

function buildHTML(items, totalPrice, d, v) {
  var linhas = '';
  var subtotalOrig = 0;
  items.forEach(function(item) {
    subtotalOrig += (item.compare_at_price || item.price) * item.qty;
    var precoUnit = formatMoney(item.price);
    var precoOrig = (item.compare_at_price && item.compare_at_price > item.price)
      ? '<span style="text-decoration:line-through;color:#aaa;font-size:11px">' + formatMoney(item.compare_at_price) + '</span><br>' + precoUnit
      : precoUnit;
    var total = formatMoney(item.price * item.qty);
    var variante = (item.variant && item.variant !== 'Default Title') ? '<br><small style="color:#888">' + item.variant + '</small>' : '';
    var imgCell = item.image
      ? '<img src="' + item.image + '" style="width:48px;height:48px;object-fit:cover;border-radius:4px;vertical-align:middle;margin-right:8px" alt="" />'
      : '';
    linhas += '<tr style="border-bottom:1px solid #eee">';
    linhas += '<td style="padding:9px 8px;font-size:12px">' + imgCell + item.title + variante + '</td>';
    linhas += '<td style="padding:9px 8px;text-align:center;font-size:12px">' + item.qty + '</td>';
    linhas += '<td style="padding:9px 8px;text-align:right;font-size:12px">' + precoOrig + '</td>';
    linhas += '<td style="padding:9px 8px;text-align:right;font-size:12px;font-weight:600">' + total + '</td>';
    linhas += '</tr>';
  });

  var desconto = subtotalOrig > totalPrice ? subtotalOrig - totalPrice : 0;
  var descHTML = '';
  if (desconto > 0) {
    descHTML += '<tr><td colspan="3" style="text-align:right;padding:4px 8px;font-size:11px;color:#888">Desconto aplicado</td>';
    descHTML += '<td style="text-align:right;padding:4px 8px;font-size:11px;color:#1a7a45;font-weight:600">- ' + formatMoney(desconto) + '</td></tr>';
  }

  var pixDesconto = Math.round(totalPrice * 0.05);
  var totalPix = totalPrice - pixDesconto;
  var parcelamento = Math.ceil(totalPrice / 3);

  var logoHtml = window.__orcamentoLogoUrl
    ? '<img src="' + window.__orcamentoLogoUrl + '" style="height:120px;width:auto;margin:-28px -20px" alt="Luz Light" />'
    : '<div style="font-size:20px;font-weight:700;letter-spacing:2px">LUZ LIGHT</div>';

  var produtoBloco = '';
  if (items.length === 1 && window.__orcamentoProdutoImg) {
    produtoBloco = '<div class="sec">Produto</div>';
    produtoBloco += '<div style="display:flex;align-items:center;background:#f8f8f8;border-radius:6px;padding:10px;margin-bottom:12px">';
    produtoBloco += '<img src="' + window.__orcamentoProdutoImg + '" style="width:80px;height:80px;object-fit:cover;border-radius:4px;margin-right:16px;flex-shrink:0" alt="" />';
    produtoBloco += '<div><div style="font-size:13px;font-weight:600">' + items[0].title + '</div>';
    if (items[0].variant && items[0].variant !== 'Default Title') {
      produtoBloco += '<div style="font-size:11px;color:#888;margin-top:2px">' + items[0].variant + '</div>';
    }
    produtoBloco += '</div></div>';
  }

  var html = '<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"><title>Orcamento Luz Light</title>';
  html += '<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;color:#222;background:#fff;font-size:13px}.page{width:210mm;min-height:297mm;margin:0 auto;padding:14mm 16mm;background:#fff}table{width:100%;border-collapse:collapse}th{background:#333;color:#fff;padding:9px 8px;font-size:11px;text-transform:uppercase;letter-spacing:.05em;text-align:left}th.c{text-align:center}th.r{text-align:right}.pix{background:#f0faf5;border:1px solid #b2dfcb;border-radius:6px;padding:11px 14px;margin-bottom:8px;display:flex;justify-content:space-between;align-items:center}.credit{background:#f8f8f8;border:1px solid #e0e0e0;border-radius:6px;padding:11px 14px;display:flex;justify-content:space-between;align-items:center}.sec{font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#888;margin:14px 0 6px;font-weight:600}.footer{display:flex;justify-content:space-between;align-items:flex-end;margin-top:20px;padding-top:14px;border-top:1px solid #eee}@page{size:A4;margin:0}@media print{.noprint{display:none!important}.page{padding:10mm 14mm}}</style>';
  html += '</head><body><div class="page">';
  html += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;overflow:hidden">';
  html += logoHtml;
  html += '<div style="text-align:right"><div style="font-size:10px;color:#888;text-transform:uppercase">Orcamento</div>';
  html += '<div style="font-size:12px;font-weight:600;margin-top:2px">Data: ' + d + '</div>';
  html += '<div style="font-size:11px;color:#888;margin-top:1px">Valido ate: ' + v + '</div></div>';
  html += '</div><div style="border-top:2px solid #333;margin-bottom:14px"></div>';
  html += produtoBloco;
  html += '<div class="sec">Itens do pedido</div>';
  html += '<table><thead><tr><th style="width:46%">Descricao</th><th class="c" style="width:10%">Qtd</th><th class="r" style="width:22%">Unit.</th><th class="r" style="width:22%">Total</th></tr></thead>';
  html += '<tbody>' + linhas + '</tbody><tfoot>' + descHTML;
  html += '<tr style="background:#f5f5f5"><td colspan="3" style="text-align:right;padding:9px 8px;font-size:12px;font-weight:600">Subtotal</td>';
  html += '<td style="text-align:right;padding:9px 8px;font-size:13px;font-weight:700">' + formatMoney(totalPrice) + '</td></tr></tfoot></table>';
  html += '<div class="sec">Condicoes de pagamento</div>';
  html += '<div class="pix"><div><div style="font-weight:700;font-size:13px">PIX</div>';
  html += '<div style="font-size:11px;color:#1a7a45;margin-top:2px">5% de desconto &mdash; Economia de ' + formatMoney(pixDesconto) + '</div></div>';
  html += '<div style="text-align:right"><div style="font-size:16px;font-weight:700;color:#1a7a45">' + formatMoney(totalPix) + '</div>';
  html += '<div style="font-size:10px;color:#888">pagamento a vista</div></div></div>';
  html += '<div class="credit"><div><div style="font-weight:700;font-size:13px">Cartao de Credito</div>';
  html += '<div style="font-size:11px;color:#888;margin-top:2px">Em ate 3x sem juros</div></div>';
  html += '<div style="text-align:right"><div style="font-size:14px;font-weight:700">' + formatMoney(totalPrice) + '</div>';
  html += '<div style="font-size:10px;color:#888">ou 3x de ' + formatMoney(parcelamento) + ' sem juros</div></div></div>';
  html += '<div class="footer"><div style="font-size:10px;color:#888;line-height:1.9">luzlight.com.br<br>contato@luzlight.com.br<br>(11) 9 6346-7797 &mdash; Seg. a Sex. 10h as 18h<br>';
  html += '<span style="font-size:9px;color:#bbb">Valido por 7 dias a partir de ' + d + '</span></div>';
  html += '<div style="text-align:center"><img src="' + QR_SITE + '" style="width:90px;height:90px;display:block;margin:0 auto" alt="QR Code" />';
  html += '<div style="font-size:9px;color:#888;margin-top:4px">Acesse nossa loja</div></div></div>';
  html += '<div class="noprint" style="text-align:center;margin-top:18px"><button onclick="window.print()" style="padding:11px 28px;background:#333;color:#fff;border:none;border-radius:6px;font-size:13px;cursor:pointer">Imprimir / Salvar PDF</button></div>';
  html += '</div></body></html>';
  return html;
}

function abrirJanela(html) {
  var w = window.open('', '_blank');
  if (w) { w.document.write(html); w.document.close(); setTimeout(function() { w.print(); }, 1000); }
  else alert('Permita popups para gerar o orcamento.');
}

function gerarOrcamentoProduto() {
  var data = window.__orcamentoProduto;
  if (!data) { alert('Dados do produto nao encontrados.'); return; }
  var hoje = new Date(), d = hoje.toLocaleDateString('pt-BR');
  var val = new Date(hoje); val.setDate(val.getDate() + 7);
  var items = [{ title: data.title, variant: data.variant, price: data.price, compare_at_price: data.compare_at_price, qty: 1, image: null }];
  abrirJanela(buildHTML(items, data.price, d, val.toLocaleDateString('pt-BR')));
}

function gerarOrcamentoCarrinho() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    if (!cart.items || !cart.items.length) { alert('Carrinho vazio.'); return; }
    var hoje = new Date(), d = hoje.toLocaleDateString('pt-BR');
    var val = new Date(hoje); val.setDate(val.getDate() + 7);
    window.__orcamentoProdutoImg = null;
    var items = cart.items.map(function(i) {
      var img = i.image ? i.image.replace(/\/([0-9]+x[0-9]+)/, '/80x80') : null;
      return { title: i.product_title, variant: i.variant_title, price: i.final_price, compare_at_price: i.compare_at_price || 0, qty: i.quantity, image: img };
    });
    abrirJanela(buildHTML(items, cart.total_price, d, val.toLocaleDateString('pt-BR')));
  }).catch(function() { alert('Erro ao gerar orcamento.'); });
}

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-orcamento]');
  if (!btn) return;
  e.preventDefault();
  var tipo = btn.getAttribute('data-orcamento');
  if (tipo === 'produto') gerarOrcamentoProduto();
  else gerarOrcamentoCarrinho();
});
